<template>
    <div :class="['layout-loader', { 'is-hidden' : !isLoading}]">
        <div class="layout-loader-logo">
            <img src="@/assets/images/logo.png" alt="logo"/>
        </div>
        <Loader :is-active="true"/>
    </div>
</template>

<script>
    import Loader from '@/components/loader/Loader'

    export default {
        name: 'LayoutLoader',
        components: {
            Loader
        },
        props: {
            isLoading: {
                type: Boolean,
                default: false
            }
        }
    }
</script>

<style lang="scss" scoped>
    .layout-loader {
        position: fixed;
        top: 0;
        left: 0;
        right: 0;
        bottom: 0;
        display: flex;
        flex-direction: column;
        justify-content: center;
        background: white;
        z-index: 20;
        text-align: center;
        transition: .3s;
        visibility: visible;


        &-logo {
            margin-bottom: 30px;
        }

        &.is-hidden {
            pointer-events: none;
            transform: scale(1.5);
            opacity: 0;
            visibility: hidden;
        }

        .loader {
            position: relative;
        }
    }
</style>
